import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  RefreshFirstReceiptStatusClientRequest,
  RefreshFirstReceiptStatusClientResponse,
} from '../../../@types/refreshFirstReceiptStatus'
import { api } from '../../../Services/API'
import { useRefreshFirstReceiptStatusStore } from '../../../Stores/useRefreshFirstReceiptStatusStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: RefreshFirstReceiptStatusClientRequest) => {
  const { data } = await api.post<RefreshFirstReceiptStatusClientResponse>(
    API_ROUTES.refreshFirstReceiptStatus,
    payload,
  )

  return data
}

export const useRefreshFirstReceiptStatus = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setRefreshFirstReceiptStatus } = useRefreshFirstReceiptStatusStore()

  return useMutation({
    mutationFn: (payload: RefreshFirstReceiptStatusClientRequest) =>
      request(payload),
    onSuccess(data) {
      setRefreshFirstReceiptStatus(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
